<template>
	<div class="bg-light-50 dark:bg-dark-800 rounded-lg">
		<div class="grid grid-cols-[auto_55px] items-center p-1 text-xs font-bold min-h-[34px] bg-dark-800 dark:bg-dark-700 rounded-t-lg text-light-50">
			<div class="px-1">
				<UiSkeleton class="h-[16px] w-10 mx-1 bg-light-500 dark:bg-dark-500" />
			</div>
			<UiSkeleton class="h-[16px] w-20] mx-1 bg-light-500 dark:bg-dark-500" />
		</div>
		<div v-for="i in 10" :key="`outright-loader-${i}`" :class="i + 1 !== 10 ? `border-b border-b-light-400 dark:border-b-dark-500` : null">
			<div class="grid grid-cols-[auto_55px] items-center p-1 text-xs">
				<div class="px-1">
					<UiSkeleton class="h-[15px] w-[100px] mx-1 bg-light-500 dark:bg-dark-500" />
				</div>
				<div class="flex justify-center">
					<UiSkeleton class="h-[32px] w-full mx-1 bg-light-500 dark:bg-dark-500" />
				</div>
			</div>
		</div>
	</div>
</template>
